module.exports = __webpack_public_path__ + "static/media/PierPass.df772095.jpeg";